<template lang='pug'>
  div.sc-visualization
    template(v-if='tableData && !tableData.length')
      StatusCero(
        :title='$t("noResults")'
        :description='$t("noVisualizationData")'
      )
    ods-scrollbar(v-else wrap-class='ods-scrollbar__wrap')
      ods-row(type='flex')
        ods-col(:span='24')
          div.table-visualization
            ods-row(type='flex')
              ods-col(:xs='24' :sm='24' :md='24')
                ods-form()
                  ods-form-item
                    ods-input(
                      size="hecto"
                      placeholder="Buscar Visualizaciones"
                      suffix-icon="ods-icon-search"
                      v-model="search")
              ods-col(:xs='24' :sm='24' :md='24')
                ods-table( ref='multipleTable' :data='tableData.filter(data => !search || data.name.toLowerCase().includes(search.toLowerCase()))' style='width: 100%'  :default-sort = "{prop: 'title', order: 'ascending'}" @selection-change="handleSelectionChange")
                  ods-table-column(type="selection" width='50')
                  ods-table-column(label='ÁREA' width='75')
                    template(slot-scope='scope')
                      app-icon-svg(:icon='scope.row.moduleCLM')
                  ods-table-column(property='name' label='TITULO' :sortable="true")
                  ods-table-column(property='createdDate' label='Fecha' :sortable="true")
                  ods-table-column(property='author' label='Autor' :sortable="true" min-width='100')
            div.table-visualization__buttons(v-if='tableData && tableData.length')
              ods-button(plain size="small" @click="closeDialog()") {{ $t('cancel') }}
              ods-button(plain size="small" @click="updateSelection()") {{ $t('update') }}
</template>

<script>

import IconSvg from '@/components/IconSvg'
import StatusCero from '@/components/StatusCero'
import ModalGeneric from '@/components/ModalGeneric'

export default {
  name: 'VisualizationDashboard',
  data () {
    return {
      tableData: [],
      search: null,
      multipleSelection: []
    }
  },
  props: {
    dataVisualizations: {
      type: Array
    }
  },
  components: {
    appIconSvg: IconSvg,
    StatusCero,
    ModalGeneric
  },
  methods: {
    setDetailView (data) {
      this.tableData = data
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    toggleSelection (rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row)
        })
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    },
    updateSelection (multipleSelection) {
      this.$emit('setDataVisualization', this.multipleSelection)
      this.$emit('hideDialogAlert')
    },
    closeDialog () {
      this.$emit('hideDialogAlert')
    }
  },
  mounted () {
    this.tableData = this.dataVisualizations
  }
}
</script>

<style lang='scss' scoped>

  .sc-visualization{
    height: 100%;
    .ods-icon-arrow-right{
      cursor: pointer;
    }
  }

  .table-visualization{
    /deep/ .ods-form-item{
      margin-bottom: rem(10);
    }
    /deep/ .ods-table {
      width: 97%;
      .cell, .ods-table th div{
        padding-left: rem(15);
      }
      &__body-wrapper .selected-row>td {
        background-color: $--color-primary-light-5;
        border-bottom: 1px solid $--color-primary;
      }
      &__body-wrapper .selected-row>td::before {
        content: "";
        top: 0;
        opacity: .75;
        left: 0;
        display: inline-block;
        height: 1px;
        background: $--color-primary;
        width: 100%;
        position: absolute;
      }
    }
    /deep/ .ods-scrollbar__table {
      height: 60vh;
      padding-right: rem(32);
      width: 100%;
    }
    &__buttons{
      display: block;
      margin-top: rem(24);
      text-align: right;
      width: 100%;
    }
  }

  /deep/ .ods-dialog.sc-modal {
    .ods-scrollbar__wrap{
      height: calc(100% - -17px);
      max-height: inherit;
      ods-scrollbar__view{
        height: 100%;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/TableAndSearch.vue